module.exports = __webpack_public_path__ + "img/summary-dispute-accept.0d579fb1.svg";